import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
 

import { Zona } from '../Models/Zona';

@Injectable()
export class ZonaService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }

/**
 * Obtiene todas las zonas de la compañia
 * @param compania Codigo de la compañia
 */
  ObtenerZonas(compania: string): Observable<Zona[]> {

    try {

      let url = this._utiles.getURL("zona/" + compania  );


      return this._http.get(url).map((response: Response) => {
        return <Zona[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

/**
 * Guarda la zona
 * @param zona Objeto de tipo Zona
 */
  public GuardarRegistro(zona: Zona) : Observable<any> {

    try {

      let params = JSON.stringify(zona);

      let url = this._utiles.getURL("zona/");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;


		return this._http.post(url, zona, {headers: headers}).map(res => res.json());


    } catch (error) {
      console.log(error);
    }


  }


}
